import {
  SET_LOADING,
  SET_NEW_TRUSTED,
  RESET_PARAMS,
  ADD_FILE_PATH_LOADED,
} from '../actions/paramsActions';

const initialState = {
  isLoading: true,
  isNewTrusted: false,
  loadedFilePaths: [],
};

export default function (state = initialState, action) {
  let nextState;
  switch (action.type) {
    case SET_LOADING:
      nextState = {
        ...state,
        isLoading: action.value,
      };
      return nextState || state;
    case SET_NEW_TRUSTED:
      nextState = {
        ...state,
        isNewTrusted: action.value,
      };
      return nextState || state;
    case RESET_PARAMS:
      return initialState;
    case ADD_FILE_PATH_LOADED:
      nextState = {
        ...state,
        loadedFilePaths: [
          ...state.loadedFilePaths,
          action.value,
        ],
      };
      return nextState || state;
    default:
      return state;
  }
}
